export default {
	checkPermissionAndAlert(permissionName,successCallback,failCallback){
		successCallback()
	}
}